import MuiTextField from "../../components/common/text-field/MuiTextField";
import UploadInput from "../../components/common/upload-input/UploadInput";
import { Stack } from "@mui/material";
import { useLangContext } from "../../context/langContext";
import { FormEvent, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { FileUploadRequest } from "../../services/Endpoints/files/FileUploadEndpoint";
import { useFormDataAxiosInstance } from "../../hooks/axiosInstance";
import { useFilesContext } from "../../context/myFilesContext";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import { useWorkspaceContext } from "../../context/workspaceContext";

const _compInfos = {
  en: {
    label: "Description",
    name: "description",
    placeholder: "لطفا متن مورد نظر خود را بنویسید",
    buttonText: "confirm",
  },
  fa: {
    label: "توضیحات",
    name: "description",
    placeholder: "لطفا متن مورد نظر خود را بنویسید",
    buttonText: "تایید",
  },
};

const successMsg = {
  fa: "فایل با موفقیت آپلود شد.",
  en: "File uploaded successfully.",
};

export default function UploadNewFileForm() {
  const { lang } = useLangContext();
  const [waiting, setWaiting] = useState(false);
  const [file, setFile] = useState<File | null>();
  const protectedFormDataInstance = useFormDataAxiosInstance();
  const [description, setDescription] = useState("");
  const { workspace } = useWorkspaceContext();
  const { setNewUploadOpen, setFileReload, fileReload } = useFilesContext();
  const { setNotification } = useNotificationContext();
  const info = _compInfos[lang];
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      description && formData.append("caption", description);
      if (!file) {
        return;
      }
      file && formData.append("file", file);
      setWaiting(true);
      const fileUploadRequest = new FileUploadRequest(
        protectedFormDataInstance
      );

      const resp = await fileUploadRequest.send(
        { workspaceId: workspace?.id ?? 1 },
        formData
      );
      setWaiting(false);
      setNewUploadOpen(false);
      setFileReload(!fileReload);
      setNotification({ type: "success", message: successMsg[lang] });
    } catch (error: any) {
      errorResolver({ error, setNotification });
      setWaiting(false);
    }
  };

  const handleDescChange = (e: any) => {
    setDescription(e.target.value);
  };

  return (
    <Stack
      component="form"
      direction="column"
      gap="8px"
      onSubmit={handleSubmit}
    >
      <UploadInput
        id="uploadFile"
        handleChangeFile={setFile}
        accept="audio"
        maxSize={5000000}
      />
      <Stack sx={{ mt: "16px" }} gap="8px">
        <MuiTextField
          width="100%"
          label={info.label}
          placeholder={info.placeholder}
          name={info.name}
          type="text"
          multiline={true}
          value={description}
          handleChange={handleDescChange}
        />
      </Stack>

      <LoadingButton variant="confirm" type="submit" loading={waiting}>
        {info.buttonText}
      </LoadingButton>
    </Stack>
  );
}
